import React from "react";
import { Box, Checkbox, Input, Text } from "@showitinc/showit-wc";
import HelpConstants from "../../../constants/HelpConstants";
import styles from "./SiteSettingsModal.module.css";
import { initFormatter } from "../../../utils/PropertyFormatters";

const META_PIXEL_ID = "metaPixelID";

const MetaPixel = ({ siteSettings, onChange }) => {
  const metaPixelId = siteSettings.getIn(["config", META_PIXEL_ID], "");
  const { onChange: _onChange } = initFormatter((propInfo) => {
    const trimmedPropInfo = { ...propInfo, value: propInfo.value.trim() };
    onChange(trimmedPropInfo);
  });

  return (
    <Box mb="3">
      <Box p="3">
        <Text variant="heading-1" className={styles.codeTitle}>
          Meta Pixel
        </Text>
      </Box>
      <Box px="3" pb="3">
        <Text variant="small" variantStyle="light">
          Meta Pixel is a tracking code that allows you to track and optimize your marketing
          efforts. &nbsp;
          <a href={HelpConstants.META_PIXEL} target="_blank" rel="noreferrer">
            Learn More
          </a>
        </Text>
      </Box>
      <Box mb="2">
        <Input
          className={styles["text-field"]}
          bordered
          type="text"
          propName={`config.${META_PIXEL_ID}`}
          label="Meta Pixel ID"
          value={metaPixelId}
          onSIInput={_onChange(`config.${META_PIXEL_ID}`)}
          onSIChange={_onChange(`config.${META_PIXEL_ID}`)}
          placeholder="XXXXXXXXXXXXXXXX"
          longLabel
        />
      </Box>
      <Box d="flex" mb="2">
        <Checkbox
          className={styles.checkbox}
          checked={siteSettings.getIn(["config", "metaPixelSkipWP"], false)}
          label="Do not include on blog templates"
          onSIChange={(e) => onChange({ name: "config.metaPixelSkipWP", value: e.target.checked })}
        />
      </Box>
    </Box>
  );
};

export default MetaPixel;
